export const terms = {
  type: 'terms',
  title: '이용약관 동의',
  contents: `제 1 조 (목적)
  본 이용약관은 팀 커넥팅칩스(이하 “팀”)에서 제공하는 웹앱 “작심삼칩”에 의해 제공되는 정보 및 제반 서비스(이하 "서비스")를 이용하는 고객(이하 “회원”)과 “팀” 간의 권리, 의무 및 책임, 기타 필요한 사항을 규정함을 목적으로 합니다.
  
  <br/>

  제 2 조 (정의)
  이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
  1. “작심삼칩”이라 함은 회원이 직접 미션을 고르고 3일마다 작심을 반복시켜 회원의 좋은 운동 습관을 유지시키는 것을 도와주는 서비스입니다.
  2. “서비스”라 함은 구현되는 단말기(PC, TV, 휴대폰 등 각종 유무선 장치를 포함)의 종류와 상관없이 “팀”에 의해 제공되는 작심삼칩 및 작심삼칩 관련 제반 서비스를 의미합니다.
  3. “회원”이라 함은 “팀”의 “서비스”의 사용에 동의하여 이 약관에 따라 “팀”과 이용계약을 체결하고 “팀”이 제공하는 “서비스”를 이용하는 고객을 말합니다.
  4. "아이디(ID)"라 함은 “회원”의 식별과 "서비스" 이용을 위하여 “회원”이 정하고 "팀"이 승인하는 이메일 “아이디(ID)”를 의미합니다.
  5. “비밀번호”라 함은 “회원”이 부여받은 "아이디(ID)”와 일치되는 “회원”임을 확인하고 비밀보호를 위해 “회원” 자신이 정한 문자 또는 숫자의 조합을 의미합니다.
  
  <br/>

  제 3 조 (약관의 게시와 개정)
  1. “팀”은 이 약관의 내용을 “회원”이 쉽게 알 수 있도록 회원 가입 시 및 “서비스”가 구현된 장치의 마이페이지에 게시합니다.
  2. “팀”은 이 약관의 내용과 상호, 연락처(전자우편주소 등) 등을 “회원”이 알 수 있도록 회원 가입 시 및 “서비스”가 구현된 장치의 설정 메뉴에 게시합니다.
  3. ”팀”은 “약관의 규제에 관한 법률”, “정보통신망 이용촉진 및 정보보호 등에 관한 법률”(이하 “정보통신망법”) 등 관련법령을 위반하지 않는 범위에서 이 약관을 개정할 수 있으며, 이 경우에는 적용일자 및 개정사유, 변경되는 내용을 명시하여 현행 약관과 함께 1항의 방식에 따라 그 적용일자 7일 전(“회원”에게 불리하거나 중대한 사항의 변경은 30일 전)부터 적용일자 전일까지 공지합니다.
  4. 제3항에 따라 개정된 약관은 “회원”이 명시적인 반대의사를 표시하지 않는 한 제3항에서 정한 공지기간이 종료됨과 동시에 효력이 발생합니다.
  5. “회원”은 변경된 약관에 동의하지 않을 경우 “서비스” 이용을 중단하고 회원 탈퇴를 요청할 수 있습니다. 변경된 약관의 공지기간 종료 이후 “회원”의 계속적인 “서비스” 이용은 이 약관의 변경사항에 동의한 것으로 간주됩니다.
  
  <br/>

  제 4 조 (약관의 해석)
  이 약관에서 정하지 아니한 사항에 대해서는 법령 또는 팀이 정한 서비스의 개별약관, 운영정책 및 규칙 등 (이하 세부지침)의 규정에 따릅니다. 또한 본 약관과 세부지침이 충돌할 경우에는 세부지침에 따릅니다. 
  
  <br/>
  
  제 5 조 (이용계약 체결)
  1. “서비스” 이용 계약은, “서비스”의 이용이 가능한 기기를 보유하게 된 자가 각각 이 약관에 동의한다는 의사표시와 함께 서비스 이용을 승낙함으로써 체결됩니다.
  2. “회원”은 본인 인증을 통해 본인의 정보를 제공하여야만 “서비스”를 이용할 수 있으며, 타인의 정보를 도용하거나 허위의 정보를 등록하는 등 본인의 진정한 정보를 등록하지 않은 경우 “서비스”와 관련하여 어떠한 주장도 할 수 없으며, 관련 법령에 따라 처벌받을 수 있습니다.
  
  <br/>

  제6조 (“서비스” 승낙의 제한)
  “팀”은 다음 각 호에 해당하는 “서비스” 이용 신청에 대하여는 이를 승낙하지 아니하거나 해당 사유가 해소될 때까지 승낙을 유보할 수 있습니다.
  1. 다른 사람의 정보를 사용하는 등 가입 신청의 내용을 허위로 기재하거나 필수적으로 기재가 요구되는 사항을 누락한 경우
  2. 영리를 추구할 목적 등 부정한 용도로 “서비스”를 이용하고자 하는 경우
  3. 법령위반 또는 사회의 안녕과 질서 혹은 미풍양속을 저해할 목적으로 신청한 경우
  4. 이 약관에 근거하여 “팀”이 이용계약을 해지한 전(前)”회원”이 재가입신청을 하는 경우
  5. 이 약관에 위배되거나 위법 또는 부당한 가입신청임이 확인된 경우
  6. 기타 이용신청자의 귀책사유로 이용승낙이 곤란한 경우
  
  <br/>

  제7조 (이용계약의 종료)
  1. “회원”이 이용계약을 해지하고자 하는 경우 "서비스"상에서 이용계약을 해지하고 “회원” 탈퇴를 하거나 “팀”이 정한 별도의 방법으로 “팀”에 해지신청을 하여야 합니다.
  2. “회원”의 해지
     - (1) “회원”은 “팀”에 해지의사를 통지함으로써 언제든지 이용계약을 해지하고 “회원탈퇴”를 할 수 있습니다.
     - (2) 위와 같은 요청을 받은 “팀”은 “팀”이 고지한 방법에 따라 신속하게 “회원탈퇴”를 처리합니다. 다만, 본인확인 절차가 필요한 경우에는 신분증 또는 “팀”이 인정하는 본인의 신분을 확인할 수 있는 증서의 제출을 요청할 수 있습니다.
  3. “팀”의 해지
     - (1) “팀”은 다음과 같은 사유가 있는 경우 “회원”에게 해지의 의사를 통지하여 이용계약을 해지할 수 있습니다. 다만, “팀”는 해당 “회원”에게 사전에 해지사유에 대한 의견진술의 기회를 부여할 수 있습니다.
         - 가. “회원”에게 이 약관에서 정하고 있는 이용계약의 승낙 제한 사유가 있음이 확인된 경우
         - 나. “회원”이 “팀”이나 다른 “회원” 기타 타인의 권리나 명예, 신용 기타 정당한 이익을 침해하는 행위를 한 경우
         - 다. “회원”이 “팀”이 제공하는 “서비스”의 원활한 진행을 방해하는 행위를 하거나 이를 시도한 경우
         - 라. 기타 “회원”이 해당 약관에 위배되거나 “서비스”와 관련하여 위법한 행위를 한 경우
     - (2) 이용계약의 종료와 관련하여 발생한 손해는 이용계약이 종료된 해당 “회원”이 책임을 부담하여야 하고, “팀”은 일체의 책임을 지지 않습니다.
  
  <br/>

  제 8 조 (회원 정보의 변경)
  1. “회원”은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 이메일(ID) 등은 수정이 불가능합니다.
  2. “회원”은 회원 가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 "팀"에 대하여 그 변경사항을 알려야 합니다.
  3. 제2항의 변경사항을 "팀"에 알리지 않아 발생한 불이익에 대하여 "팀"은 책임지지 않습니다.
  
  <br/>

  제 9 조 (“회원”에 대한 통지)
  1. "팀"이 “회원”에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 전자우편주소, 전자쪽지 등으로 할 수 있습니다.
  2. "팀"은 “회원” 전체에 대한 통지의 경우 7일 이상 "팀"의 "웹사이트" 또는 서비스 내 "공지사항" 화면에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.
  
  <br/>

  제 10 조 (“팀”의 의무)
  1. “팀”은 관련법과 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 지속적이고 안정적으로 "서비스"를 제공하는데 최선을 다하여야 합니다.
  2. "팀"은 서비스이용과 관련하여 “회원” 으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 “회원”에게 처리과정 및 결과를 전달합니다.
  3. 아래의 사항에 해당될 경우 개인정보 공개 및 상실에 대하여 "팀"은 책임을 지지 않습니다.
    (1) 회원의 부주의로 "비밀번호"가 유출되어 개인정보가 공개되는 경우
    (2) 회원이 각종 삭제 기능을 사용하여 내용을 삭제하였을 경우
    (3) 천재지변이나 그 밖의 "팀"이 통제할 수 없는 상황에 의하여 내용이 공개되거나 상실되었을 경우
  
  <br/>

  제 11 조 (“회원”의 의무)
  1. “회원”은 이 약관 및 관계 법령에서 규정한 사항을 준수하여야 합니다.
  2. “회원”은 다음 행위를 하여서는 안됩니다.
    - “팀”, 기타 제3자의 저작권 등 지적재산권에 대한 침해
    - “팀”, 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
    - 외설 또는 폭력적인 메시지, 화상, 음성 기타 미풍양속에 반하는 정보를 공개 또는 게시하는 행위
    - 기타 불법적이거나 부당한 행위
    - 팀이 게시한 정보의 변경
    - 타인의 정보도용
    - 서비스 신청, 변경 시 허위정보의 등록
    - "팀"의 사전 동의 없이 영리 목적의 광고성 정보를 전송하기 위하여 이용하는 행위
    - 리버스엔지니어링, 디컴파일, 디스어셈블 및 기타 일체의 가공행위를 통하여 서비스를 복제, 분해 모방 또는 기타 변형하는 행위
    - 자동 접속 프로그램 등을 사용하는 등 정상적인 용법과 다른 방법으로 서비스를 이용하여 "팀"의 서버에 부하를 일으켜 팀의 정상적인 서비스를 방해하는 행위
    - 본인 아닌 제3자에게 접속권한을 부여하는 행위
    - 서비스에 기초하여 2차적 저작물을 만드는 행위
    - 악의적 또는 부정적인 방법으로 작심삼칩 서비스를 이용하는 행위 (예: 해킹 또는 바이러스와 같은 악성코드나 유해한 데이터를 배포하는 행위 등)
    - 서비스와 서버 간의 전송 신호를 해독하려는 시도하거나, 서비스 또는 시스템으로부터 데이터나 정보를 수집하는 모든 행위
  3. “회원”은 “팀”에서 공식적으로 인정한 경우를 제외하고는 “서비스”를 이용하여 상품을 판매하는 영업 활동을 할 수 없으며 특히 해킹, 광고를 통한 수익, 음란사이트를 통한 상업행위, 상용소프트웨어 불법전송 등을 할 수 없습니다. 이를 위반하여 발생한 영업 활동의 결과 및 손실, 관계기관에 의한 구속 등 법적 조치 등에 관해서는 “팀”이 책임을 지지 않으며, 이와 같은 행위로 인하여 “팀”에게 손해가 발생한 경우, “회원”은 “팀”에 대하여 손해배상 의무를 집니다.
  4. “회원”이 이 약관의 규정을 위반함으로 인하여 “팀”에 손해가 발생하게 되는 경우, 이 약관을 위반한 “회원”은 “팀”에 발생하는 모든 손해를 배상할 책임이 있습니다.
  5. “회원”이 본 서비스를 이용함에 있어 행한 불법행위나 이 약관의 위반행위로 인하여 “팀”이 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 “회원”은 자신의 책임과 비용으로 “팀”을 면책시켜야 하며, “팀”이 면책되지 못한 경우 당해 “회원”은 그로 인하여 “팀”에 발생한 모든 손해를 배상하여야 합니다.
  
  <br/>

  제 12 조 (미션 인증)
  1. “회원"은 미션을 인증할 때 다른 “회원”이 미션의 인증을 위해 등록한 “이미지, 동영상, 게시물 등"을 확인할 수 있습니다.
  2. “회원"은 미션 인증 이외의 목적으로 다른 “회원"이 등록한 “이미지, 동영상, 게시물 등"을 복제, 공연, 공중송신, 전시, 배포, 방송, 2차적 저작물 작성 기타의 방법으로 이용하거나 제3자에게 이용하도록 해서는 안 됩니다.
  3. “회원"은 미션 인증과 무관하거나 음란, 저속한 정보를 교류, 게재하거나 사회통념상 타인에게 불쾌감을 줄 수 있는 내용을 “이미지, 동영상, 게시물 등"을 게재해서는 안 됩니다. 만약 이러한 경우 “팀"는 “회원"에게 통지 없이 “이미지, 동영상, 게시물 등"을 삭제할 수 있습니다.
  
  <br/>

  제 13 조 (서비스의 제공 등)
  1. “서비스” 이용은 “팀”의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다. “팀”은 “서비스”를 일정 범위로 분할하여 각 범위 별로 이용 가능한 시간을 별도로 정할 수 있으며, 이 경우 그 내용을 인터넷 사이트 등에 공지합니다.
  2. “팀”은 다음 각 호에 해당하는 경우 “서비스”의 전부 또는 일부를 영구히 또는 일시적으로 제한하거나 중단할 수 있습니다.
     (1) 컴퓨터 등 정보통신설비의 보수·점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우
     (2) 설비의 보수 등 공사로 인해 부득이한 경우
     (3) 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 “서비스” 이용에 지장이 있는 경우
     (4) “회원”이 “팀”의 영업활동을 방해하는 경우
     (5) “서비스” 제공업자와의 계약종료 등 “팀”의 제반 사정으로 해당 “서비스”를 유지할 수 없는 경우
     (6) 기타 천재지변, 국가비상사태 등 불가항력의 사유가 있는 경우
     (7) “팀”의 사업계획의 변경 또는 경영상의 사유로 더 이상의 “서비스” 제공이 불가능할 경우
  3. “서비스” 중단의 경우 “팀”은 중단될 “서비스”의 내용 및 제공일자를 제9조에서 정한 게시의 방법으로 “회원”에게 통지를 갈음할 수 있습니다. 단, “팀”의 고의·과실이 없는 시스템 장애, 천재지변 등 기타 불가피한 사유로 인하여 “서비스”를 중단하게 되어 사전 통지가 불가능한 경우에는 “회원”에게 미리 통지하지 못할 수도 있습니다.
  4. “팀”에 고의 또는 중과실이 없는 경우 “팀”은 “서비스”의 중단으로 발생하는 문제에 대해서 일체의 책임을 지지 않습니다.
  
  <br/>

  제 14 조 (“서비스”의 변경 및 중단)
  1. “팀”은 이용 감소로 인한 원활한 “서비스” 제공의 곤란 및 수익성 악화, 기술 진보에 따른 차세대 “서비스”로의 전환 필요성, “서비스” 제공과 관련한 “팀” 정책의 변경 등 기타 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 "서비스"를 수정, 변경 또는 중단할 수 있습니다.
  2. “팀”은 무료로 제공되는 “서비스”의 일부 또는 전부를 “팀”의 정책, 및 운영의 필요상 언제든지 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 “회원”에게 별도의 보상을 하지 않습니다.
  3. “팀”은 정보통신 시스템 등의 정기점검, 보수, 교체, 고장, 통신두절 또는 운영상의 상당한 이유가 있는 경우에는 “서비스”의 제공을 일시 중단할 수 있습니다. 이 경우 팀은 사전에 회원에게 통지합니다. 다만, 팀이 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
  4. 서비스의 내용, 이용방법, 이용시간에 대하여 변경 또는 서비스 중단이 있는 경우에는 변경 또는 중단될 서비스의 내용 및 사유와 일자 등은 그 변경 또는 중단 전에 “웹사이트” 또는 ‘서비스’내 “공지사항 화면 등 회원이 충분히 인지할 수 있는 방법으로 7일 이상 게시하는 방법으로 공지합니다.
  5. “팀”은 본 “서비스”의 변경, 중지로 발생하는 손해 등 어떠한 문제에 대해서도 책임 지지 않습니다.
  6. 팀은 약관을 수정할 수 있으며, 변경된 약관 내용을 팀의 웹사이트에 공지합니다. 만일 사용자에게 중대한 영향을 미칠 수 있는 사항이 있다면, 팀 계정에 등록된 이메일이나 개별 서비스를 통한 고지 등의 적절한 방법으로 알려드리겠습니다.
  7. 변경사항은 변경 약관에 별도로 명시된 시행일자부터 적용됩니다. 변경된 약관에 동의하지 않으면, 서비스를 사용하지 못할 수도 있습니다. 변경약관에 동의하지 않아도, 변경 약관의 시행일자가 지난 후에도 서비스를 계속 이용하고 있다면, 팀은 사용자가 변경된 약관에도 동의한 것으로 이해합니다.
  
  <br/>

  제 15 조 (정보의 제공 및 광고의 게재)
  “팀"은 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 회원에게 제공할 수 있습니다.
  
  <br/>

  제 16 조 (개인정보보호 의무)
  "팀"은 "정보통신망 이용촉진 및 정보보호 등에 관한 법률" 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 "팀"의 개인정보처리방침이 적용됩니다. 다만, "팀"의 공식 사이트 이외의 링크된 사이트에서는 "팀"의 개인정보처리방침이 적용되지 않습니다.
  
  <br/>
  
  제 17 조 (“회원”의 개인정보 관리에 대한 의무)
  1. “회원”의 "아이디(ID)"와 "비밀번호"에 관한 관리책임은 “회원”에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.
  2. “회원”은 “팀”이 정한 기준을 충족하는 범위 내에서 자유롭게 “비밀번호”를 정할 수 있으며, 정해진 “비밀번호”는 “회원”이 원하는 경우 언제든지 변경이 가능합니다.
  3. “회원”은 “비밀번호”에 대한 보호 및 관리 책임을 부담합니다. 다만, “팀”은 보안 등을 이유로 “회원”에게 정기적 또는 비정기적으로 “비밀번호”의 변경을 권고할 수 있습니다.
  4. "팀"은 “회원”의 "아이디(ID)"가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 "팀" 및 "팀"의 운영자로 오인할 우려가 있는 경우, 해당 "아이디(ID)"의 이용을 제한할 수 있습니다.
  5. “회원”은 "아이디(ID)" 및 "비밀번호"가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 "팀"에 통지하고 "팀"의 안내에 따라야 합니다.
  6. 제3항의 경우에 해당 “회원”이 "팀"에 그 사실을 통지하지 않거나, 통지한 경우에도 "팀"의 안내에 따르지 않아 발생한 불이익에 대하여 "팀"은 책임지지 않습니다.
  
  <br/>

  제 18 조 (권리의 귀속)
  1. “회원”의 “게시물”이 정보통신망법 및 저작권법 등 관련 법령에 위반되는 내용을 포함하는 경우, 관리자는 관련 법령이 정한 절차에 따라 해당 “게시물”의” 게시중단 및 삭제 등을 요청할 수 있으며, “팀”은 관련 법령에 따라 조치를 취하여야 합니다.
  2. “팀”은 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 “팀” 정책 및 관련 법령에 위반되는 경우에는 관련 법령에 따라 해당 "게시물"에 대해 임시조치 등을 취할 수 있습니다.
  3. “회원”은 “팀”의 “서비스”를 이용함으로써 얻은 모든 정보와 자료(게시물 등의 글, 도안, 음성, 사진, 동영상을 포함하며, 이에 국한되지 아니합니다)를 “팀” 및 권리 소유자의 명시적인 사전승낙 없이 복제, 공연, 공중송신, 전시, 배포, 방송, 2차적 저작물 작성 기타의 방법으로 이용하거나 제3자에게 이용하도록 하여서는 아니 됩니다.
  
  <br/>

  제 19 조 (이용제한 등)
  1. "팀"은 “회원”이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 계약해지 등으로 “서비스”의 이용을 단계적으로 제한할 수 있습니다.
  2. "팀"은 전항에도 불구하고, "주민등록법"을 위반한 명의도용 및 결제도용, "저작권법" 및 "컴퓨터프로그램보호법"을 위반한 불법 프로그램의 제공 및 운영방해, “정보통신망법"을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 계약해지를 할 수 있습니다. 본 항에 따른 계약해지 시 서비스 이용을 통해 획득한 혜택 등도 모두 소멸되며, 팀은 이에 대해 별도로 보상하지 않습니다.
  3. 팀은 이용제한정책 등에서 제한의 조건 및 세부내용을 정하되, 본 조의 이용제한 범위를 벗어나지 않습니다.
  4. 본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 "팀"은 제9조[“회원”에 대한 통지]에 정한 방법에 따라 통지합니다.
  
  <br/>

  제 20 조 (책임제한)
  1. “팀”은 천재지변 또는 이에 준하는 불가항력으로 인하여 “서비스”를 제공할 수 없는 경우에는 “서비스” 제공에 관한 책임이 면제됩니다.
  2. "팀"은 “회원”의 귀책사유로 인한 "서비스" 이용의 장애에 대하여는 책임을 지지 않습니다.
  3. "팀"은 “회원”이 "서비스"와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.
  4. "팀"은 “회원” 간 또는 “회원”와 제3자 상호간에 "서비스"를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.
  5. "팀"은 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.
  6. "팀"은 제3자가 서비스 내 화면 또는 링크된 웹사이트를 통하여 광고한 제품 또는 서비스의 내용과 품질에 대하여 감시할 의무 기타 어떠한 책임도 지지 아니합니다.
  7. "팀"및 "팀"의 임직원 그리고 대리인은 다음과 같은 사항으로부터 발생하는 손해에 대해 책임을 지지 아니합니다.
     (1) “회원” 개인정보의 허위 또는 부정확성에 기인하는 손해
     (2) 그 성질과 경위를 불문하고 "서비스"에 대한 접속 및 "서비스"의 이용과정에서 발생하는 개인적인 손해
     (3) 서버에 대한 전송 또는 서버로부터의 전송에 대한 제3자의 모든 불법적인 방해 또는 중단행위로부터 발생하는 손해
     (4) 제3자가 "서비스"를 이용하여 불법적으로 전송, 유포하거나 또는 전송/유포되도록 한 모든 바이러스, 스파이웨어 및 기타 악성 프로그램으로 인한 손해
     (5) 전송된 데이터의 오류 및 생략, 누락, 파괴 등으로 발생되는 손해
     (6) “회원”간의 “회원” 개인정보 등록 및 "서비스" 이용 과정에서 발생하는 명예훼손
     (7) 기타 불법행위로 인한 각종 민형사상 책임
  8. “서비스”와 관련하여 “회원”과 제3자 간에 발생한 분쟁이 발생한 경우 “팀”은 그 분쟁에 개입하지 않으며 그 분쟁의 결과에 책임이 없습니다. 이와 관련하여 “팀”이 제3자에게 손해를 배상하거나 기타 비용을 지출한 경우 “팀”은 “회원”에게 구상권을 행사할 수 있습니다.
  
  <br/>

  제 21 조 (팀의 연락처)
  "팀"의 상호 및 주소 등은 다음과 같습니다.
    - 상호: 팀 커넥팅칩스
    - 메일: connectingchips@gmail.com 
  
  <br/>
  제 22 조 (해외이용)
  "팀"은 “회원”이 대한민국의 영토 이외의 지역에서 "서비스"를 이용하고자 하는 경우 "서비스"의 품질 또는 사용성을 보장하지 않습니다. 따라서 “회원”이 대한민국의 영토 이외의 지역에서 "서비스"를 이용하고자 하는 경우 스스로의 판단과 책임에 따라서 이용 여부를 결정하여야 하고, 특히 "서비스"의 이용과정에서 현지 법령을 준수할 책임은 “회원”에게 있습니다.
  
  <br/>

  제 23 조 (재판관할 및 준거법)
  1. "팀"과 “회원”간 제기된 소송은 대한민국법을 준거법으로 합니다.
  2. "팀"과 “회원”간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.
  
  <br/>
  
  제 24 조 (계약의 효력)
  이 서비스와 관련하여 "팀"과 “회원”간 체결되는 본 약관은 완전한 계약으로 기존에 맺어진 이와 상충하는 어떠한 구두나 서면에 의한 합의, 계약 등 보다 우선하여 적용되며, 관계법령 등에 따라 그 중 일부가 무효가 되더라도 나머지 조항은 그대로 유효하게 적용됩니다.
  
  <br/>
  
  공고일자: 2023년 9월 22일
  시행일자: 2023년 9월 22일
  `,
};

export const privacyPolicy = {
  type: 'privacyPolicy',
  title: '개인정보 처리 방침 동의',
  contents: `팀 커넥팅칩스(이하 "팀"이라 함)는 개인정보 보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법"이라 함) 등 팀이 준수하여야 할 국내 개인정보 보호 법령을 준수하며, 관련 법령에 의거한 개인정보 처리방침을 정하여 회원의 권익 보호에 최선을 다하고 있습니다.
  본 개인정보 처리방침은 팀이 운영하는 웹앱 작심삼칩 관련 제반 서비스(이하 “서비스”)에 적용되며 다음과 같은 내용을 담고 있습니다.
  이 개인정보 처리방침에서 사용하는 용어의 의미는 관련 법령 및 팀의 이용약관에서 정한 바에 따르며, 그 밖의 사항은 일반적인 상관례에 따릅니다.
  본 개인정보 처리 방침은 관련 법령의 개정이나 팀의 정책에 의해 변경될 수 있으며 변경되는 경우 “회원”에게 사전 공지합니다.
  
  1. 개인정보의 수집 및 이용
  2. 개인정보 처리 위탁
  3. 개인정보 제3자 제공
  4. 회원 및 법정대리인의 권리와 그 행사방법
  5. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
  6. 개인정보의 파기절차 및 방법
  7. 기타
  
  <br/>

  1. 개인정보의 수집 및 이용
  
  (1) 수집하는 개인정보 항목 및 수집 방법

  <br/>

  가. 수집 항목
  1) 서비스 및 동기화 서비스 공통
  
  가) 작심삼칩 서비스 프로필 정보

  - 성별,생년월일,닉네임,프로필 사진

  나) 회원 정보: ID, 이름, 전화번호, 회원email, 설정언어, 국가코드, 단말기내 전화번호부내 전화번호 목록 (이름, e-mail, 전화번호), 단말ID, 메시징 서비스 ID(구글,애플,카카오톡 등)
  - 어플리케이션 내 각종 사용기록(화면/메뉴 진입, 버튼 선택과 같은 어플리케이션 내 기능사용, 사용 중 발생하는 오류)
  - 회원이 작성한 게시글 등 회원 활동정보
  - 앱 버전, 마지막 로그인 일시, 마케팅 수신동의날짜, 국가, 언어, 지역코드

  다) 작심삼칩과 연동된 제3자 서비스 이용과정에서 생성된 정보(계정 토큰정보 등)

  라) 고객센터를 통한 상담 및 문의 시 이름, 이메일, 전화번호 등의 정보가 선택항목으로 수집됩니다.

  마) 자동 수집: 접속로그 등

  바) 쿠키(cookie), 서비스 이용 기록, 불량 이용 기록 등이 생성되어 수집될 수 있습니다.

  기타 특정 목적을 위해 개인정보를 수집할 수 있습니다. 단, 이때에는 별도 약관을 고지하고 추가 동의를 받습니다.

  \n
  나. 수집 방법
  1) 작심삼칩을 통한 "서비스" 실행 또는 이용 과정에서 수집, 로그분석 프로그램을 통한 자동 로그 수집
  2) 고객센터를 통한 상담 과정에서 이름, 이메일, 전화번호 등을 통해 회원의 개인정보가 수집될 수 있습니다.
  
  (2) 개인정보 수집 및 이용목적
  작심삼칩 앱은 수집한 개인정보를 다음의 목적을 위해 활용합니다.
  
  가. "서비스" 제공에 관한 계약 이행
  - 맞춤형 컨텐츠 및 추천 기능 제공
  - 기존 작심삼칩 서비스 개선 및 신규서비스 개발
  - 서비스 이용에 대한 분석 및 통계
  
  나. "회원" 관리: "서비스" 이용에 따른 본인확인, 개인 식별, 불량 "회원"의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 가입 및 가입횟수 제한, 분쟁 처리를 위한 기록 보존, 불만 민원 처리, 고지사항 전달 등
  
  다. 제품 개발·개선, 서비스 개선을 위한 통계 및 분석 (특정 개인을 알아볼 수 없는 형태로 활용)
  
  (3) 개인정보 보유 및 이용기간
  “회원”의 개인정보는 “서비스” 가입기간 동안 이용 및 보관함을 원칙으로 하며, 서비스 탈퇴 등 개인정보 수집 및 이용목적이 달성된 후에는 해당정보를 지체없이 파기합니다.
  단, 회원에게 개인정보 보관기간에 대해 별도의 동의를 얻은 경우, 또는 법령에서 일정 기간 정보보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를 안전하게 보관합니다.
  - 작심삼칩 동기화 서비스는 동기화가 가능한 기간 동안의 데이터만 보관합니다.
  - “서비스” 이용 등에 관한 분쟁에 대비하고 “회원”이 “회원” 탈퇴한 후 “회원” 재가입, 임의 해지 등을 반복적으로 행함으로써 본 “서비스”가 제공하는 이벤트 혜택 등의 경제상의 이익을 불·편법적으로 수취하거나 이 과정에서 명의도용 등의 행위가 발생하는 것을 방지하기 위한 목적으로 “회원” 탈퇴 후 1년 동안 “회원”님의 개인정보를 보관합니다.
  또한, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 팀은 법령에서 정한 바에 따라 일정한 기간 동안 개인 정보를 보관할 수 있습니다.
  - 계약 또는 청약철회 등에 관한 기록 보유: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
  - 대금결제 및 재화 등의 공급에 관한 기록 보유: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
  - 소비자 불만 또는 분쟁처리에 관한 기록 보유: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)
  - 방문에 관한 기록 보유: 3개월 (통신비밀보호법)
  - 본인확인에 관한 기록 보유: 6개월 (정보통신 이용촉진 및 정보보호 등에 관한 법률)
  
  2. 개인정보 처리 위탁
  팀은 서비스 향상 등을 위하여 아래와 같이 개인정보의 처리를 위탁하고 있으며, 위탁 받은 업체가 개인정보 보호법 등 관계 법령에 따라 개인정보를 안전하게 처리하도록 필요한 사항을 규정하고 관리와 감독을 실시하고 있습니다.
  
  규정하고 관리와 감독을 실시하고 있습니다.
  (1) Amazon Web Service
  수탁 업무 내용 : 데이터 보관 및 인프라 운영
  개인정보 보유 및 이용 기간 : 회원 탈퇴 시 또는 위탁 계약 종료시까지
  위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개 하도록 하겠습니다.
  
  3. 개인정보 제3자 제공
  팀은 회원의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
  (1) 회원이 사전에 동의한 경우: 팀은 제3자에게 회원의 개인정보를 제공할 경우 반드시 사전에 회원의 동의를 받을 것입니다.
  (2) 법령의 규정에 의한 경우이거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
  
  4. 회원 및 법정대리인의 권리와 그 행사방법
  (1) 개인정보 열람, 정정, 삭제 요구의 권리
  회원은 언제든지 등록되어 있는 자신의 개인정보를 열람하거나 정정할 수 있고 삭제를 요구할 수 있습니다. 개인정보 열람, 정정 및 삭제를 하고자 할 경우에는 팀의 개인정보보호책임자 및 담당자에게 서면, 전화 또는 전자우편으로 연락하면 지체 없이 조치하도록 하겠습니다. 다만, 회원은 다른 법령에서 그 개인정보가 수집대상으로 명시되어 있는 경우에는 삭제를 요구할 수 없으며, 개인정보를 정정·삭제하는 경우에 일부 또는 전부의 서비스 이용이 불가능할 수 있습니다.
  (2) 개인정보 처리정지 요구의 권리
  회원은 언제든지 등록되어 있는 자신의 개인정보의 처리정지를 요청할 수 있습니다. 개인정보 처리의 정지를 원하는 경우 팀의 개인정보보호책임자 및 담당자에게 서면, 전화 또는 전자우편으로 연락하면 지체 없이 조치하도록 하겠습니다. 다만, 팀은 관련 법령에 따라 회원의 처리정지 요청에도 불구하고 계속하여 개인정보를 처리할 수 있으며, 이러한 경우에는 지체 없이 그 내용을 회원에게 알려드리도록 하겠습니다. 이에 대하여 회원은 개인정보보호책임자 및 담당자에게 서면, 전화 또는 전자우편 등의 방법을 통하여 이의를 제기할 수 있습니다.
  (3) 개인정보 수집, 이용, 제공에 대한 동의 철회의 권리
  회원은 언제든지 등록되어 있는 자신의 개인정보의 수집, 이용, 제공에 대한 동의를 철회할 수 있습니다. 이를 위하여 팀의 개인정보보호책임자 및 담당자에게 서면, 전화 또는 전자우편으로 연락할 수도 있습니다. 이러한 경우 팀은 본인 확인 절차 후 개인정보의 삭제 등 필요한 조치를 하겠습니다.
  
  5. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
  팀은 서비스를 운영하는 과정에서 회원의 서비스 최초 이용 시 서비스 이용에 필요한 아래와 같은 항목을 자동으로 수집하기 위하여, 회원의 정보를 수시로 저장하고 찾아내는 "쿠키(cookie)"등 개인정보를 자동으로 수집하는 장치를 설치 운용합니다.
  *쿠키란 작심삼칩 서비스를 운영하는데 이용되는 서버가 회원의 브라우저에 보내는 아주 작은 텍스트 파일로서 회원의 컴퓨터 하드디스크에 저장됩니다. 회원은 언제든지 개인정보의 자동수집을 거부할 수 있습니다. 회원이 위 정보들의 자동수집을 거부하는 경우, 관련 서비스를 이용하지 못할 수 있습니다.
  
  가. 자동수집항목
  쿠키, 접속 로그(IP포함), 연결 기기 정보 (OS, 국가 및 언어, Time zone, 식별정보, 광고식별자 등), 기기 사용 정보, Accessory주변기기 정보, 서비스 이용 정보
  
  나. 자동수집 목적
  작심삼칩 서비스 사용 행태 분석, 맞춤형 서비스 제공, 제품 수행 결과 확인, 제품 및 서비스 개발 목적 등
  
  6. 개인정보의 파기절차 및 방법
  팀은 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.
  파기절차 및 방법은 다음과 같습니다.
  
  (1) 파기절차
  - 회원이 서비스 이용을 위해 입력한 정보는 개인정보의 수집 및 이용 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기됩니다.
  - 별도 DB로 옮겨진 개인정보는 법률에 의한 경우를 제외하고 보유되는 이외의 다른 목적으로 이용되지 않습니다.
  - 팀은 "개인정보 유효기간제"에 따라 1년간 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관하여 관리하고 있습니다. 단, "개인정보 유효기간을 회원 탈퇴 시 까지"로 설정한 경우에는 해당되지 않습니다.
  
  (2) 파기방법
  - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
  - 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
  
  7. 기타
  팀에 링크되어 있는 웹사이트 등이 개인정보를 수집하는 행위에 대해서는 팀의 개인정보처리방침이 적용되지 않음을 알려 드립니다.
  
  9. 개인정보보호책임자의 연락처
  팀은 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보보호책임자를 지정하고 있습니다.
  
  <br/>

  개인정보보호책임자
    - 이름: 박준형
    - 소속: 팀 커넥팅칩스
    - 직위: PM
  이메일 : connectingchips@gmail.com 
  
  <br/>

  귀하께서는 팀의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보보호책임자 혹은 담당부서로 신고하실 수 있습니다. 팀은 회원들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.
  
  기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.

  - 개인정보 침해신고센터 : (국번없이)118 (https://privacy.kisa.or.kr/)

  - 개인정보 분쟁조정위원회 : 1833-6972 (http://www.kopico.go.kr/)

  - 대검찰청 사이버수사과 : 
  (국번없이)1301, cid@spo.go.kr (https://spo.go.kr/)

  - 경찰청 사이버수사국 : (국번없이)182 (https://ecrm.cyber.go.kr)
  
  <br/>

  제정일자: 2023년 9월 22일
  시행일자: 2023년 9월 22일`,
};

export const personalInfoCollection = {
  type: 'personalInfoCollection',
  title: '개인정보 수집 및 이용 동의',
  contents: `팀 커넥팅칩스(이하 “팀”)는 「개인정보 보호법」에 따라 최초 회원가입 신청하시는 분께 수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간, 동의 거부권 및 동의 거부 시 불이익에 관한 사항을 안내 드리오니, 자세히 읽은 후 동의하여 주시기 바랍니다.
  
  <br/>

  개인정보 처리에 대한 상세한 사항은 서비스 설정에 공개한 "개인정보 처리방침"을 참조하십시오. 다만, 동의서 내용과 상충되는 부분은 본 동의서의 내용이 우선합니다.
  
  <br/>

  1. 수집하는 개인정보 항목 및 수집 방법
  팀은 서비스 제공을 위해 아래와 같은 개인정보를 수집하고 있습니다.
  
  (1) 수집 항목
  
  1. 공통
  · 프로필 정보: 닉네임, 프로필 사진
  · 계정 정보: 회원 이메일, 로그인 ID
  · 고객센터를 통한 상담 및 문의 시: 이름, 이메일, 전화번호 등의 정보가 선택항목으로 수집
  · 기타: 쿠키(cookie), 서비스 이용 기록, 불량 이용 기록 등이 생성되어 수집될 수 있습니다.
  
  1. 개인정보 수집 및 이용목적
  
  (1) 회원 가입 및 관리
  
  - 회원 가입의사 확인, 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지, 고충처리 목적
  
  (2) 서비스 제공 및 개선
  
  - 콘텐츠 제공, 맞춤 서비스 제공
  - 서비스 개선, 신규 서비스 개발, 서비스 이용에 대한 분석 및 통계 목적
  
  1. 개인정보 보유 및 이용기간
  팀은 서비스 이용기간 동안 이용자의 개인정보를 이용∙보관하며 회원탈퇴 시 개인정보를 지체없이 파기함을 원칙으로 합니다. 다만, 팀은 관계 법령의 규정 및 팀 내부 방침에 의하여 개인정보를 보존할 필요가 있는 경우 일정한 기간 동안 해당 개인 정보를 보관합니다.
  
  (1) 관계 법령의 규정이 있는 경우
  
  1. 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시·광고, 계약내용 및 이행 등 거래에 관한 기록
      - 표시·광고에 관한 기록: 6개월
      - 계약 또는 청약철회, 대금결제, 재화 등의 공급기록: 5년
      - 소비자 불만 또는 분쟁처리에 관한 기록: 3년
  2. 「통신비밀보호법」에 따른 통신사실확인자료 보관
      - 가입자 전기통신일시, 개시·종료시간, 상대방 가입자번호, 사용도수, 발신기지국 위치추적자료: 1년
      - 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료, 방문에 관한 기록: 3개월
      - 개별적으로 “회원”의 동의를 받은 경우: 동의를 받은 기간
      - 서비스 이용 등에 관한 분쟁 대응 및 “회원”이 탈퇴 후 재가입, 임의 해지 등을 반복적으로 행함으로써 본 서비스가 제공하는 이벤트 혜택 등의 경제상의 이익을 불·편법적으로 수취하거나 이 과정에서 명의도용 등의 행위 방지: 탈퇴일로부터 1년
  
  (2) 팀 내부 방침에 따라 보유하는 개인정보의 보존 기간
  
  1. 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료시까지
  2. 홈페이지 이용에 따른 채권·채무관계 잔존 시에는 해당 채권·채무관계 정산시까지
  3. 서비스 이용 등에 관한 분쟁 대응 및 회원이 탈퇴 후 재가입, 임의 해지 등을 반복적으로 행함으로써 본 서비스가 제공하는 이벤트 혜택 등의 경제상의 이익을 불·편법적으로 수취하거나 이 과정에서 명의도용 등의 행위 방지: 탈퇴일로부터 1년
  
  1. 동의를 거부할 권리 및 동의 거부에 따른 불이익
  회원은 개인정보의 수집 및 이용 등과 관련한 위 사항에 대하여 원하지 않는 경우 동의를 거부할 수 있습니다. 다만, 동의를 거부하는 경우 서비스의 이용이 제한될 수 있음을 알려 드립니다.`,
};
